import React, { useState } from 'react';
import { Order } from '../../dto/Profile.dto';
import './styles/Orderinfo..css';
import './styles/OrderinfoMobile.css';
import CancelOrderModal from './CancelOrderModal';

interface OrderInfoProps {
  order: Order | null;
  onOrderCancelled?: () => void;
}

const Orderinfo: React.FC<OrderInfoProps> = ({ order, onOrderCancelled }) => {
  const [showCancelModal, setShowCancelModal] = useState(false);

  const getDeliveryTime = () => {
    if (!order || order.status !== 'delivered') return null;

    const createdAt = new Date(order.createdAt);
    let deliveredAt: Date | null = null;

    // Try actualDeliveryTime first
    if (order.trackingInfo?.actualDeliveryTime) {
      deliveredAt = new Date(order.trackingInfo.actualDeliveryTime);
    } else if (order.trackingInfo?.trackingHistory) {
      // Find the delivered entry
      const deliveredEntry = order.trackingInfo.trackingHistory.find(
        entry => entry.status === 'delivered'
      );
      if (deliveredEntry) {
        deliveredAt = new Date(deliveredEntry.timestamp);
      }
    }

    if (!deliveredAt) return null;

    const diffMs = deliveredAt.getTime() - createdAt.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const remainingMinutes = diffMinutes % 60;

    if (diffHours > 0) {
      return `Arrived in ${diffHours}h ${remainingMinutes}m`;
    } else {
      return `Arrived in ${diffMinutes} Min`;
    }
  };

  const deliveryTime = getDeliveryTime();
  const trackingStatus = order?.trackingInfo?.status;
  const canCancel = ['pending', 'paid'].includes(order?.status?.toLowerCase() || '')
    && trackingStatus?.toLowerCase?.() !== 'out_for_delivery';

  return (
    <div className="orderinfo-card">
      <div className="orderinfo-left">
        <h1 className="orderinfo-title">Order Details</h1>
        <div className="orderinfo-content">
          <div className="orderinfo-id-row">
            <div className="orderinfo-top-row">
              <span className="orderinfo-label">Order Id</span>
              <span className="orderinfo-value">#{order?.orderId || order?._id || 'N/A'}</span>
              <span className="orderinfo-status">{order?.status || 'Status not available'}</span>
            </div>
            <p className="orderinfo-date">
              Placed on {order?.createdAt ? new Date(order.createdAt).toLocaleDateString() : 'Date not available'}
            </p>
          </div>
        </div>
      </div>

      <div className="orderinfo-right">
        <button className="orderinfo-help-btn">
          <svg className="orderinfo-help-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 13.5C18 14.163 17.7366 14.7989 17.2678 15.2678C16.7989 15.7366 16.163 16 15.5 16H5.5L2 19.5V4.5C2 3.83696 2.26339 3.20107 2.73223 2.73223C3.20107 2.26339 3.83696 2 4.5 2H15.5C16.163 2 16.7989 2.26339 17.2678 2.73223C17.7366 3.20107 18 3.83696 18 4.5V13.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Get Help
        </button>
        
        {canCancel && (
          <button 
            className="orderinfo-cancel-btn"
            onClick={() => setShowCancelModal(true)}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Cancel Order
          </button>
        )}
        
        {deliveryTime && (
          <div className="orderinfo-arrival-badge">
            {deliveryTime}
          </div>
        )}
      </div>

      {showCancelModal && (
        <CancelOrderModal
          orderId={order?._id || ''}
          orderStatus={order?.status || ''}
          trackingStatus={trackingStatus || ''}
          onClose={() => setShowCancelModal(false)}
          onSuccess={() => {
            setShowCancelModal(false);
            onOrderCancelled?.();
          }}
        />
      )}
    </div>
  );
};

export default Orderinfo;